<script>
import store from '../store'
import modelPickerItem from './model-picker-item'

export default {
  name: 'modelPicker',
  components: {
    modelPickerItem
  },
  computed: {
    showDialog: {
      get: function () {
        let modelState = store.getters['model/getState']
        return modelState.modelPicker
      },
      set: function (newValue) {
        store.commit('model/setProperty', {property: 'modelPicker', value: newValue})
      }
    },
    scenes () {
      return store.getters['scenes/getState']
    },
    sceneLoaded () {
      return store.getters['scenes/getsceneLoaded']
    },
    chunkedScenes () {
      const chunkedArr = []
      let index = 0
      while (index < this.scenes.length) {
        chunkedArr.push(this.scenes.slice(index, 3 + index))
        index += 3
      }
      return chunkedArr
    }
  }
}
</script>

<template>
  <md-dialog class="masonry" :md-fullscreen=false :md-click-outside-to-close=false :md-active.sync="showDialog">
    <md-dialog-title>Pick a model</md-dialog-title>
    <md-dialog-content class="md-layout md-alignment-top-space-between">
      <modelPickerItem v-for="(scene, index) in scenes" :key="index" v-bind:scene="scene"/>
    </md-dialog-content>
    <md-dialog-actions v-if="sceneLoaded">
      <md-button class="md-transparent md-raised" @click="showDialog = false">Keep my current model</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<style lang="scss" scoped>
  .md-dialog {
    min-width: 740px;

    @media screen and (max-width: 768px) {
      min-width: 100%;
      min-height: 100%;
    }
    @media screen and (min-width: 1279px) {
      min-width: 1060px;
    }
  }
</style>
